import * as firebase from 'firebase';
import _ from 'lodash';

export const FETCH_SLIDES = 'fetch_slides';
export const FETCH_SLIDES_SUCCESS = 'fetch_slides_success';

export function fetchAllSlides() {

    const slidesRef = firebase.database().ref('slideshows');

    return dispatch => {
        dispatch({ type: FETCH_SLIDES });

        slidesRef.on('value', snapshot => {
            const value = snapshot.val();

            if (value) {

                let rawSlides = [];
                snapshot.forEach(rawSlide => {
                    const slideId = rawSlide.key;
                    const slide = rawSlide.val();

                    rawSlides.push({ ...slide, slideId: slideId });
                });

                const sorted = _.sortBy(rawSlides, s => {
                    return s.order;
                });

                dispatch({
                    type: FETCH_SLIDES_SUCCESS,
                    payload: value,
                    sorted: sorted
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/Slideshow.js